<div mat-dialog-content class="mat-dialog-content">
  <img src="../../../../../../../assets/images/patient-pic-1.jpg" alt="">
</div>
<!-- <div mat-dialog-actions class="mat-dialog-actions" align="end">
  <button mat-button mat-dialog-close  mat-raised-button style="margin: 0 2px;">×</button>
</div> -->